/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface CampaignPostRequest
 */
export interface CampaignPostRequest {
  /**
   * auto-create default call and sms rules with default timegate settings
   * @type {boolean}
   * @memberof CampaignPostRequest
   */
  autoCreate?: boolean;
  /**
   * optional caller_id in E164 format
   * @type {string}
   * @memberof CampaignPostRequest
   */
  callerId?: string;
  /**
   * When to end campaign
   * @type {Date}
   * @memberof CampaignPostRequest
   */
  dateScheduledEnd?: Date;
  /**
   * When to start campaign
   * @type {Date}
   * @memberof CampaignPostRequest
   */
  dateScheduledStart?: Date;
  /**
   * the dialpad Target id calls/texts will be associated with
   * @type {number}
   * @memberof CampaignPostRequest
   */
  groupId: number;
  /**
   * auto-generated display name of campaign
   * @type {string}
   * @memberof CampaignPostRequest
   */
  name?: string;
  /**
   * Set the default timegate settings for the campaign
   * @type {boolean}
   * @memberof CampaignPostRequest
   */
  setTimegate?: boolean;
}

/**
 * Check if a given object implements the CampaignPostRequest interface.
 */
export function instanceOfCampaignPostRequest(
  value: object,
): value is CampaignPostRequest {
  if (!('groupId' in value) || value['groupId'] === undefined) return false;
  return true;
}

export function CampaignPostRequestFromJSON(json: any): CampaignPostRequest {
  return CampaignPostRequestFromJSONTyped(json, false);
}

export function CampaignPostRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CampaignPostRequest {
  if (json == null) {
    return json;
  }
  return {
    autoCreate: json['auto_create'] == null ? undefined : json['auto_create'],
    callerId: json['caller_id'] == null ? undefined : json['caller_id'],
    dateScheduledEnd:
      json['date_scheduled_end'] == null
        ? undefined
        : new Date(json['date_scheduled_end']),
    dateScheduledStart:
      json['date_scheduled_start'] == null
        ? undefined
        : new Date(json['date_scheduled_start']),
    groupId: json['group_id'],
    name: json['name'] == null ? undefined : json['name'],
    setTimegate:
      json['set_timegate'] == null ? undefined : json['set_timegate'],
  };
}

export function CampaignPostRequestToJSON(
  value?: CampaignPostRequest | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    auto_create: value['autoCreate'],
    caller_id: value['callerId'],
    date_scheduled_end:
      value['dateScheduledEnd'] == null
        ? value['dateScheduledEnd']
        : value['dateScheduledEnd'].toISOString(),
    date_scheduled_start:
      value['dateScheduledStart'] == null
        ? value['dateScheduledStart']
        : value['dateScheduledStart'].toISOString(),
    group_id: value['groupId'],
    name: value['name'],
    set_timegate: value['setTimegate'],
  };
}
